import { Typography as TypoGraphyComp, TypographyProps } from "@mui/material";

export default function Typography({
  fontSize = 14,
  fontFamily = "Google Sans",
  lineHeight = "15px",
  style,
  className,
  children,
  fontWeight = 400,
  color,
  fontStyle,
}: TypographyProps) {
  return (
    <TypoGraphyComp
      fontSize={fontSize}
      fontFamily={fontFamily}
      lineHeight={lineHeight}
      style={style}
      className={className}
      fontWeight={fontWeight}
      color={color}
      fontStyle={fontStyle}
      sx={{ textTransform: "none" }}
    >
      {children}
    </TypoGraphyComp>
  );
}
